var map = {
	"./ion-action-sheet.entry.js": [
		460,
		5
	],
	"./ion-alert.entry.js": [
		461,
		6
	],
	"./ion-app_8.entry.js": [
		462,
		7
	],
	"./ion-avatar_3.entry.js": [
		463,
		17
	],
	"./ion-back-button.entry.js": [
		464,
		18
	],
	"./ion-backdrop.entry.js": [
		465,
		43
	],
	"./ion-button_2.entry.js": [
		466,
		19
	],
	"./ion-card_5.entry.js": [
		467,
		20
	],
	"./ion-checkbox.entry.js": [
		468,
		21
	],
	"./ion-chip.entry.js": [
		469,
		22
	],
	"./ion-col_3.entry.js": [
		470,
		44
	],
	"./ion-datetime_3.entry.js": [
		471,
		10
	],
	"./ion-fab_3.entry.js": [
		472,
		23
	],
	"./ion-img.entry.js": [
		473,
		45
	],
	"./ion-infinite-scroll_2.entry.js": [
		474,
		46
	],
	"./ion-input.entry.js": [
		475,
		24
	],
	"./ion-item-option_3.entry.js": [
		476,
		25
	],
	"./ion-item_8.entry.js": [
		477,
		26
	],
	"./ion-loading.entry.js": [
		478,
		27
	],
	"./ion-menu_3.entry.js": [
		479,
		28
	],
	"./ion-modal.entry.js": [
		480,
		8
	],
	"./ion-nav_2.entry.js": [
		481,
		14
	],
	"./ion-popover.entry.js": [
		482,
		9
	],
	"./ion-progress-bar.entry.js": [
		483,
		29
	],
	"./ion-radio_2.entry.js": [
		484,
		30
	],
	"./ion-range.entry.js": [
		485,
		31
	],
	"./ion-refresher_2.entry.js": [
		486,
		11
	],
	"./ion-reorder_2.entry.js": [
		487,
		16
	],
	"./ion-ripple-effect.entry.js": [
		488,
		47
	],
	"./ion-route_4.entry.js": [
		489,
		32
	],
	"./ion-searchbar.entry.js": [
		490,
		33
	],
	"./ion-segment_2.entry.js": [
		491,
		34
	],
	"./ion-select_3.entry.js": [
		492,
		35
	],
	"./ion-slide_2.entry.js": [
		493,
		48
	],
	"./ion-spinner.entry.js": [
		494,
		13
	],
	"./ion-split-pane.entry.js": [
		495,
		49
	],
	"./ion-tab-bar_2.entry.js": [
		496,
		36
	],
	"./ion-tab_2.entry.js": [
		497,
		15
	],
	"./ion-text.entry.js": [
		498,
		37
	],
	"./ion-textarea.entry.js": [
		499,
		38
	],
	"./ion-toast.entry.js": [
		500,
		39
	],
	"./ion-toggle.entry.js": [
		501,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		502,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 305;
module.exports = webpackAsyncContext;